import { MyProfileData } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchMyProfile } from './MyProfileSlice';
import { MyProfileSelector } from './MyProfileSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useMyProfile(): AbstractDataState<MyProfileData, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyProfile, MyProfileSelector);
}
